import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AdminCenterSetting from '../../components/admin/AdminCenterSetting';
import { loadCenters, updateCenterManagerFlag, registCenter } from '../../lib/api/clubs';

const AdminCenterSettingContainer = () => {
  const { socketKey } = useSelector(({ socket }) => ({
    socketKey: socket.socketKey,
  }));

  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [keyword, setKeyword] = useState('');
  const [savingIds, setSavingIds] = useState(() => new Set());

  const fetchCenters = useCallback(async () => {
    if (!socketKey) return;
    setLoading(true);
    setError(null);
    try {
      const res = await loadCenters({ socketKey });
      const list = Array.isArray(res?.data) ? res.data : [];
      setCenters(list);
    } catch (e) {
      console.error('loadCenters error:', e);
      setError('센터 목록을 불러오지 못했습니다.');
      setCenters([]);
    } finally {
      setLoading(false);
    }
  }, [socketKey]);

  useEffect(() => {
    fetchCenters();
  }, [fetchCenters]);

  const handleCreateCenter = useCallback(
    async ({ centerName, account, password, phone }) => {
      if (!socketKey) {
        alert('소켓 키가 없습니다. 다시 로그인해 주세요.');
        return false;
      }

      try {
        const res = await registCenter({
          name: centerName,
          account,
          centerName,
          password,
          phone,
          sex: 1,
          birth: '19900101',
          socketKey,
        });

        const data = res?.data;
        if (data?.centerInfo?.centerID) {
          alert('센터가 생성되었습니다.');
          await fetchCenters();
          return true;
        }

        if (data?.error) {
          alert(data.error);
        } else if (data?.result && data.result !== 1 && data.result !== 'SUCCESS') {
          alert(String(data.result));
        } else {
          alert('센터 생성에 실패했습니다.');
        }
        return false;
      } catch (e) {
        console.error('registCenter error:', e);
        alert('센터 생성 중 오류가 발생했습니다.');
        return false;
      }
    },
    [socketKey, fetchCenters],
  );

  return (
    <AdminCenterSetting
      centers={centers}
      loading={loading}
      error={error}
      keyword={keyword}
      onChangeKeyword={(e) => setKeyword(e.target.value)}
      onRefresh={fetchCenters}
      savingIds={savingIds}
      onCreateCenter={handleCreateCenter}
      onEditManagerFlag={(centerID, currentFlag) => {
        const nextFlag = currentFlag === 1 ? 0 : 1;
        const ok = window.confirm(
          `대시보드 사용을 변경하시겠습니까?`,
        );
        if (!ok) return;

        const idNum = Number(centerID);
        setSavingIds((prev) => {
          const next = new Set(prev);
          next.add(idNum);
          return next;
        });

        (async () => {
          try {
            const res = await updateCenterManagerFlag({
              centerID: idNum,
              managerFlag: nextFlag,
              socketKey,
            });
            const result = res?.data?.result;

            console.log(res?.data, "res?.data")
            if (result === 1 || result === 'SUCCESS') {
              setCenters((prev) =>
                (Array.isArray(prev) ? prev : []).map((c) =>
                  Number(c.centerID) === idNum
                    ? { ...c, managerFlag: nextFlag }
                    : c,
                ),
              );
            } else {
              alert('managerFlag 변경에 실패했습니다.');
            }
          } catch (e) {
            console.error('updateCenterManagerFlag error:', e);
            alert('managerFlag 변경 중 오류가 발생했습니다.');
          } finally {
            setSavingIds((prev) => {
              const next = new Set(prev);
              next.delete(idNum);
              return next;
            });
          }
        })();
      }}
    />
  );
};

export default AdminCenterSettingContainer;

